"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const __1 = require("../..");
const Field_Constant_1 = require("../controller/utils/Field.Constant");
const Page_Function_1 = require("./utils/Page.Function");
const RenderCard = React.forwardRef(({ post, renderCard, classNameCard, index }, ref) => {
    return (React.createElement(React.Fragment, null, React.createElement("div", { className: ` ${Field_Constant_1.TEXT_AUTHOR}-card ${classNameCard}`, ref: ref }, renderCard({ data: post, index }))));
});
const PageInfinityScroller = ({ api = "", path = "", limit = 10, params = false, renderCard = () => {
    React.createElement("div", null, "Body");
}, renderLoading = React.createElement("div", null, "Loading..."), renderError = () => {
    React.createElement("div", null, "Error!");
}, debounceParams = 1000, classNameCard = "", method = "GET", keyName = "", }) => {
    const [data, setData] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState("");
    const [skip, setSkip] = React.useState(0);
    const [hasMore, setHasMore] = React.useState(true);
    const [count, setCount] = React.useState(0);
    const [loadingMore, setLoadingMore] = React.useState(false);
    const thisPath = path.slice(1);
    (0, Page_Function_1.useDebounceEffect)(() => {
        setSkip(0);
        setHasMore(true);
        setData([]);
        setCount(0);
        FunctionLoadData();
    }, [params], debounceParams);
    const FunctionLoadData = () => __awaiter(void 0, void 0, void 0, function* () {
        if (api && path && hasMore) {
            setLoading(true);
            const string_params = (0, Page_Function_1.FunctionUseParams)(Object.assign(Object.assign({}, params), { skip: 0, limit }));
            try {
                if (method === "GET") {
                    const { data } = yield api.get(path + string_params);
                    setCount(data.count);
                    setSkip(1);
                    if (keyName) {
                        setData(data[keyName]);
                    }
                    else {
                        setData(data[thisPath]);
                    }
                }
                else if (method === "POST") {
                    const { data } = yield api.post(path + string_params);
                    setCount(data.count);
                    setSkip(1);
                    if (keyName) {
                        setData(data[keyName]);
                    }
                    else {
                        setData(data[thisPath]);
                    }
                }
                else {
                    throw new Error("Method not supported");
                }
            }
            catch (error) {
                setError(error);
                console.error("ERROR TO LOAD DATA : ", error);
            }
            finally {
                setLoading(false);
            }
        }
        else {
            return;
        }
    });
    const FunctionLoadMore = () => __awaiter(void 0, void 0, void 0, function* () {
        if (api && path && count > 0 && (data === null || data === void 0 ? void 0 : data.length) > 0) {
            if (skip * limit >= count && count > 0) {
                setHasMore(false);
                return;
            }
            else {
                setLoadingMore(true);
                const string_params = (0, Page_Function_1.FunctionUseParams)(Object.assign(Object.assign({}, params), { skip: skip * limit, limit }));
                try {
                    if (method === "GET") {
                        const { data } = yield api.get(path + string_params);
                        setSkip((prev) => prev + 1);
                        if (keyName) {
                            setData((prev) => {
                                let cloneData = (0, __1.FunctionCloneDeep)(prev);
                                return [...cloneData, ...data[keyName]];
                            });
                        }
                        else {
                            setData((prev) => {
                                let cloneData = (0, __1.FunctionCloneDeep)(prev);
                                return [...cloneData, ...data[thisPath]];
                            });
                        }
                    }
                    else if (method === "POST") {
                        const { data } = yield api.post(path + string_params);
                        setSkip((prev) => prev + 1);
                        if (keyName) {
                            setData((prev) => {
                                let cloneData = (0, __1.FunctionCloneDeep)(prev);
                                return [...cloneData, ...data[keyName]];
                            });
                        }
                        else {
                            setData((prev) => {
                                let cloneData = (0, __1.FunctionCloneDeep)(prev);
                                return [...cloneData, ...data[thisPath]];
                            });
                        }
                    }
                    else {
                        throw new Error("Method not supported");
                    }
                }
                catch (error) {
                    setError(error);
                    console.error("ERROR TO LOAD MORE DATA : ", error);
                }
                finally {
                    setLoadingMore(false);
                }
            }
        }
        else {
            return;
        }
    });
    const intObserver = React.useRef();
    const ReferenceOfContent = React.useCallback((post) => {
        if (loadingMore)
            return;
        if (intObserver.current)
            intObserver.current.disconnect();
        intObserver.current = new IntersectionObserver((posts) => {
            if (posts[0].isIntersecting && hasMore) {
                FunctionLoadMore();
            }
        });
        if (post)
            intObserver.current.observe(post);
    }, [hasMore, FunctionLoadMore]);
    const content = data.map((post, index) => {
        if (data.length === index + 1) {
            return (React.createElement(RenderCard, { ref: ReferenceOfContent, key: `key-of-scroll-${index}`, post: post, renderCard: renderCard, classNameCard: classNameCard, index: index }));
        }
        return (React.createElement(RenderCard, { key: `key-of-scroll-${index}`, post: post, renderCard: renderCard, classNameCard: classNameCard, index: index }));
    });
    if (error) {
        return renderError(error);
    }
    if (loading) {
        return React.createElement(React.Fragment, null, renderLoading);
    }
    return (React.createElement(React.Fragment, null,
        content,
        loadingMore && (React.createElement("div", { className: "flex justify-center" }, renderLoading))));
};
exports.default = PageInfinityScroller;
